import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  IconButton,
  Image,
  Spacer,
  Spinner,
  Tag,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import BottomDrawer from "../../components/BottomDrawer";
import {
  getMockMusicFestVenues,
  useMusicFestivalGigs,
  useMusicFestivalVenues,
} from "../../data/musicFestival.api";
import {
  Gig,
  MusicFestivalFilter,
  Venue,
  VenueAndGig,
} from "../../types/MusicFestivalTypes";
import { MapPin } from "../../components/Map";
import { MapContext } from "../../context/map.context";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import { FaFilter } from "react-icons/fa";
import { filterMusicFestVenuesAndGigs } from "./util/Filtering";
import LMFLogo from "./assets/LMFLogo.png";
import FilterTagList from "../../components/musicfestival/FilterTagList";

const GigSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlLocation = useLocation();
  const navigate = useNavigate();

  const { setPins, flyTo, setVenues } = useContext(MapContext);
  const [eventPins, setEventPins] = useState<MapPin[]>([]);
  const [locations, setLocations] = useState<Venue[]>([]);
  const [gigs, setGigs] = useState<Gig[]>([]);
  const [filterList, setFilterList] = useState<string[]>([]);
  const [noGigs, setNoGigs] = useState<boolean>(false);
  const [venuesAndGigs, setVenuesAndGigs] = useState<VenueAndGig[]>([]);
  const [filter, setFilter] = useState<MusicFestivalFilter>({
    search: "",
    location: [],
    genre: [],
    accessibility: [],
  });

  const { data: gigData, loading: gigLoading } = useMusicFestivalGigs();

  useEffect(() => {
    //@ts-ignore
    if (searchParams.size > 0) {
      const searchTerm = searchParams.get("search");
      setFilter({
        search: searchTerm !== null ? searchTerm : "",
        location: searchParams.getAll("venue"),
        genre: searchParams.getAll("genre"),
        accessibility: searchParams.getAll("accessibility"),
      });
      if (searchTerm !== null) {
        setFilterList([
          ...searchParams.getAll("genre"),
          ...searchParams.getAll("venue"),
          ...searchParams.getAll("accessibility"),
          searchTerm !== null ? searchTerm : "",
        ]);
      } else {
        setFilterList([
          ...searchParams.getAll("genre"),
          ...searchParams.getAll("venue"),
          ...searchParams.getAll("accessibility"),
        ]);
      }
    }
  }, [urlLocation.search]);

  // stores gigs
  useEffect(() => {
    if (gigData && gigData.getPublishedEvents) {
      const fetchedGigs: Gig[] = gigData.getPublishedEvents;
      setGigs(fetchedGigs);
    }
  }, [gigData]);

  // applies url filters
  useEffect(() => {
    if (gigs.length > 0) {
      let res = filterMusicFestVenuesAndGigs(gigs, filter);
      setVenuesAndGigs(res);
      if (res.length === 0) setNoGigs(true);
    }
  }, [gigs, filter]);

  // Moves map to lancaster town centre instead of university campus
  useEffect(() => {
    flyTo({
      pitch: 1,
      bearing: 1,
      zoom: 15,
      center: {
        lng: -2.803113,
        lat: 54.048958,
      },
    });
  }, [flyTo]);

  useEffect(() => {
    const pins = venuesAndGigs.map((venueAndGigs) => {
      return {
        lng: venueAndGigs.venue.longitude,
        lat: venueAndGigs.venue.latitude,
        size: 25,
        onClick: () =>
          navigate(
            `/musicfestival/search/${
              venueAndGigs.venue.id
            }?${searchParams.toString()}`
          ),
      };
    });
    setEventPins(pins);
  }, [venuesAndGigs]);

  useEffect(() => {
    setPins([...eventPins]);
  }, [eventPins, setPins]);

  //@ts-ignore
  return (
    <>
      <FilterTagList filterList={filterList} />
      <BottomDrawer ml={"4em"} goBackUrl={`/`}>
        <Box p={4}>
          <Flex mb={4} justify="space-between" align="center">
            <Heading size="md">List Of Venues</Heading>
          </Flex>
          <VStack spacing={4}>
            {gigLoading && <Spinner />}
            {!gigLoading && noGigs && venuesAndGigs.length === 0 && (
              <Text>No Venues Found - May Need To Change Your Filters</Text>
            )}
            {venuesAndGigs
              .sort((a, b) => a.venue.title.localeCompare(b.venue.title))
              .map((venueAndGigs) => {
                return (
                  <HStack
                    align={"start"}
                    w={"100%"}
                    h={"5.5em"}
                    spacing={"1em"}
                    onClick={() => {
                      navigate(
                        `/musicfestival/search/${
                          venueAndGigs.venue.id
                        }?${searchParams.toString()}`
                      );
                    }}
                  >
                    {venueAndGigs.venue.imageUrl && (
                      <Image
                        style={{ aspectRatio: "1/1" }}
                        maxH={"100%"}
                        borderRadius={"xl"}
                        src={venueAndGigs.venue.imageUrl}
                        alt="Image of music festival venue"
                      />
                    )}
                    <VStack
                      align={"start"}
                      justify={"start"}
                      h={"100%"}
                      spacing={0}
                    >
                      <Heading size={"sm"} mb={"0em"}>
                        {venueAndGigs.venue.title}
                      </Heading>
                      <Spacer />
                      <Text>{venueAndGigs.venue.description}</Text>
                      <Spacer />
                    </VStack>
                  </HStack>
                );
              })}
          </VStack>
        </Box>
      </BottomDrawer>
    </>
  );
};

export default GigSearch;
